var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignOut(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 13.333c2.2 0 4.133-1.4 4.933-3.333h1.4C13.533 12.733 11 14.667 8 14.667c-3.667 0-6.667-3-6.667-6.667s3-6.667 6.667-6.667c2.933 0 5.467 1.934 6.333 4.667h-1.4C12.133 4.067 10.2 2.667 8 2.667c-2.933 0-5.333 2.4-5.333 5.333 0 2.933 2.4 5.333 5.333 5.333z",
    fill: "#71767A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.933 7.333h7.734v1.334H6.933L8.467 10.2l-.934.933L4.4 8l3.133-3.133.934.933-1.534 1.533z",
    fill: "#71767A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOut);
export default __webpack_public_path__ + "static/media/sign-out.e18f5a385f469aab82bb4d64368780e5.svg";
export { ForwardRef as ReactComponent };